module.exports = __webpack_public_path__ + "img/IMG_5612.c14b563e.jpg";